/**
 * @author Jean-Louis Mainguy <jean-louis.mainguy@cossette.com>
 * @file Alerts
 * @description Site-wide alerts
 */


export class Alerts {

  private btns:NodeListOf<HTMLElement>;
  private alerts:NodeListOf<HTMLElement>;
  private dismissed:Array<String>
  readonly closeAlertBind:any;

  public constructor() {
    this.closeAlertBind = this.closeAlert.bind(this);
    this.btns = document.querySelectorAll('.site-alert .btn-close-alert');
    this.alerts = document.querySelectorAll('.site-alert');
    this.dismissed = []

    this.init();
  }


  private init():void {

    this.btns.forEach((btn) => {
      btn.addEventListener('click', this.closeAlertBind);
    });

    this.displayAlerts()

    // accessibility
    // this.links.forEach((link) => {
    //   link.setAttribute('tabindex', '-1');
    // });
  }

  private closeAlert(e):void {

    const alert = e.srcElement.closest('.site-alert')
    const dismissableId = alert.dataset.id

    if(!this.dismissed.includes(dismissableId) && dismissableId)
      this.dismissed.push(dismissableId)

    localStorage.setItem('dismissed', JSON.stringify(this.dismissed));
    alert.classList.remove('is-active')
    document.querySelector('body').classList.remove('has-alert')
    document.documentElement.style.removeProperty('--alert-height')
  }

  private displayAlerts() {
    const dismissed = localStorage.getItem('dismissed')

    if(dismissed) {
      this.dismissed = JSON.parse(dismissed)
    }

    let hasAlert = false
    
    this.alerts.forEach(el => {
      if(this.dismissed.length == 0 || !this.dismissed.includes(el.dataset.id)) {
        el.classList.add('is-active')
        document.documentElement.style.setProperty('--alert-height', `${el.clientHeight}px`)
        hasAlert = true
      }
    })

    if(hasAlert)
      document.querySelector('body').classList.add('has-alert')
  }
}
